import type { DecorationType } from "../types";

export type DecorationDefinition = {
  id: DecorationType;
  name: string;
  price: number;
};

export const DECORATIONS: Record<DecorationType, DecorationDefinition> = {
  fence: { id: "fence", name: "รั้วไม้", price: 12 },
  tree: { id: "tree", name: "ต้นแอปเปิล", price: 55 },
  flowers: { id: "flowers", name: "แปลงดอกไม้", price: 22 },
  catHouse: { id: "catHouse", name: "บ้านแมว", price: 80 },
};

export const DECORATION_IDS = Object.keys(DECORATIONS) as DecorationType[];
